import { render, staticRenderFns } from "./LoginBanner.vue?vue&type=template&id=12b2a889&scoped=true&"
import script from "./LoginBanner.vue?vue&type=script&lang=js&"
export * from "./LoginBanner.vue?vue&type=script&lang=js&"
import style0 from "./LoginBanner.vue?vue&type=style&index=0&id=12b2a889&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2a889",
  null
  
)

export default component.exports